import { render, staticRenderFns } from "./ContactDetailsBox.vue?vue&type=template&id=6c16ccc8&scoped=true&"
import script from "./ContactDetailsBox.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsBox.vue?vue&type=style&index=0&id=6c16ccc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c16ccc8",
  null
  
)

export default component.exports